// @ts-ignore
import styleCSS from "./loader.scss?inline"

export class LoaderComponent {
  private element: HTMLElement;

  constructor(element: HTMLElement) {
    this.element = element;
    
    // Add styles directly to the element
    const style = document.createElement('style');
    style.textContent = styleCSS;
    element.appendChild(style);

  }

  public show() {
    this.element.style.display = 'flex';
  }

  public hide() {
    this.element.style.display = 'none';
  }
}